import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getCategories, searchCategories, showDeleteCategoryModal} from './actions';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import {getTaxGroups} from "../Tax/actions";
import DeleteCategoryFormModal from "./DeleteCategoryFormModal";

class CategoriesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    search: PropTypes.object.isRequired,
    allCategories: PropTypes.array.isRequired,
    salonId: PropTypes.string.isRequired,
    taxGroups: PropTypes.array.isRequired,
    deleteCategoryModalVisible: PropTypes.bool.isRequired,
    /* actions */
    searchCategories: PropTypes.func.isRequired,
    getCategories: PropTypes.func.isRequired,
    getTaxGroups: PropTypes.func.isRequired,
    showDeleteCategoryModal: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.salonId !== prevProps.salonId) this.load();
  }

  load = () => {
    const {salonId, getCategories, getTaxGroups} = this.props;
    if (salonId) {
      getCategories({salonId});
      getTaxGroups({salonId});
    }
  };

  render() {
    const {
      history, searchCategories, salonId, taxGroups, allCategories, deleteCategoryModalVisible,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
      },
      {
        title: 'Parent',
        dataIndex: 'parentName',
        key: 'parentId',
        sorter: true,
        filters: allCategories.map(({categoryId: value, name: text}) => ({text, value})),
        render: (parentName) =>
          <span
            style={{textDecoration: 'line-through'}}
          >
            {parentName}
          </span>
      },
      {
        title: 'Tax Group',
        dataIndex: 'taxGroupName',
        key: 'taxGroupId',
        sorter: true,
        filters: taxGroups.map(({taxGroupId: value, name: text}) => ({text, value})),
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, category) => {
          return (<span><Link to={`/category/update/${encodeURIComponent(category.categoryId)}`}>Edit</Link> | <a
            onClick={() => this.props.showDeleteCategoryModal(category)}>Delete</a> </span>);
        }
      }
    ];
    return (<React.Fragment>
      {deleteCategoryModalVisible && <DeleteCategoryFormModal onDelete={() => this.listView.refresh()}/>}
      <ListView
        ref={ref => this.listView = ref}
        salonId={salonId}
        title="Categories"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchCategories}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/category/add')}
        rowKey="categoryId"
      />
    </React.Fragment>);
  }
}

const mapStateToProps = state => ({
  loading: state.category.searching || state.category.categoriesLoading || state.tax.taxGroupsLoading,
  salonId: state.salon.selectedSalonId,
  taxGroups: state.tax.taxGroups,
  search: state.category.search,
  allCategories: state.category.categories,
  deleteCategoryModalVisible: state.category.deleteCategoryModalVisible,

});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchCategories,
  getTaxGroups,
  getCategories,
  showDeleteCategoryModal,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);



// WEBPACK FOOTER //
// ./src/Category/CategoriesPage.js